<div class="tool" #toolComponent>
    <div
        class="tool__top"
        [style.width]="dynamicSize | unit: 'px'"
        [style.transform]="'translateY(' + (margin / 20 | unit) + ')'"
    >
        <!-- Due to limitations of cdkDrag, handle must to be passed as ng-content else it won't work -->
        <ng-content></ng-content>
    </div>
    <div class="tool__rings">
        @if (init) {
        <svg
            class="svg"
            [attr.height]="dynamicSize | unit: 'px'"
            [attr.width]="dynamicSize | unit: 'px'"
            [attr.viewBox]="viewBox"
        >
            <defs>
                @for (filter of interpolationFilters; track filter) {
                <filter color-interpolation-filters="sRGB" id="{{ filter.id }}">
                    <feColorMatrix
                        in="SourceGraphic"
                        type="matrix"
                        [attr.values]="filter.hex | hexToMatrix"
                        result="selectedColor"
                    />
                </filter>
                }
                <filter id="shadowOutset">
                    <feGaussianBlur stdDeviation="3" result="blurResult" />
                    <feFlood
                        flood-color="#000000"
                        flood-opacity="0.16"
                        result="colorResult"
                    />
                    <feComposite
                        in="colorResult"
                        in2="blurResult"
                        operator="in"
                        result="blurResult"
                    />
                    <feMerge>
                        <feMergeNode />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
                <filter id="shadowInset">
                    <feGaussianBlur stdDeviation="3" result="blurResult" />
                    <feComposite
                        operator="out"
                        in="SourceGraphic"
                        in2="blurResult"
                        result="inverseResult"
                    />
                    <feFlood
                        flood-color="000000"
                        flood-opacity="0.16"
                        result="colorResult"
                    />
                    <feComposite
                        operator="in"
                        in="colorResult"
                        in2="inverseResult"
                        result="shadowResult"
                    />
                    <feComposite
                        operator="over"
                        in="shadowResult"
                        in2="SourceGraphic"
                    />
                </filter>
            </defs>
            @for (ring of rings; track ring) {
            <g>
                @if (ring.visible) {
                <g [id]="'tool-ring-' + ring.id">
                    <circle
                        [attr.r]="ring.radius"
                        [attr.filter]="ring.shadow | svgUrl"
                        [ngClass]="ring.classes"
                    />
                    @for (button of ring.buttons; track button) {
                    <g
                        [id]="'tool-button-' + button.id"
                        (click)="button.handleClick()"
                        [ngClass]="button.classes"
                        [class.active]="button.isActive()"
                        [class.disabled]="button.isDisabled()"
                    >
                        <path
                            [attr.d]="button.instructions"
                            class="svg__path"
                        ></path>
                        <image
                            [attr.x]="button.iconPoint.x"
                            [attr.y]="button.iconPoint.y"
                            [attr.xlink:href]="button.icon"
                            [attr.filter]="button.iconFilter | svgUrl"
                            class="svg__icon"
                        />
                    </g>
                    }
                </g>
                }
            </g>
            }
        </svg>
        }
    </div>
</div>
